<style scoped>
</style>
<template>
	<div>
		<Table :columns="columns1" :data="ParkingLocks"></Table>
		<!-- <Modal v-model="modalView" :title="modal.Title" width="60%">
			<Form label-position="right" v-if="modal.type=='add'||modal.type=='update'" ref="FormItem" :model="FormItem"
				:label-width="90">
				<Row>
					<Col span=8>
					<FormItem label="价格id" prop="Id">
						<Input v-model="FormItem.Id" placeholder="价格id"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem label="价格名称" prop="Name">
						<Input v-model="FormItem.Name" placeholder="价格名称"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem label="设备类型" prop="EquipmentType">
						<Input v-model="FormItem.EquipmentType" placeholder="输入设备类型"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk">确定</Button>
			</div>
		</Modal> -->
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		},
		data() {
			return {
				columns1: [{
						title: '地锁编号',
						key: 'LockNo',
					}, {
						title: '地锁名称',
						key: 'LockName',
					},
					{
						title: '设备编码',
						key: 'EquipNo',
					},
					{
						title: '车位号',
						key: 'ParkNo',
					},
					{
						title: '备注',
						key: 'Remarks',
					}
				],
				//设备信息中的枪信息列表
				ParkingLocks: this.row.ParkingLocks,
				//价格信息
				FormItem: {},
				//时段价格model
				modal: {
					Title: "设备添加",
					type: "add"
				},
				modalView: false
			}
		},

		methods: {
		// 	show: function(type, LockNo) {
		// 		const _this = this;
		// 		console.log(LockNo)
		// 		for (let i = 0; i < _this.row.ParkingLocks.length; i++) {
		// 			if (LockNo == _this.row.ParkingLocks[i].LockNo) {
		// 				_this.FormItem = _this.row.ParkingLocks[i].PriceInfo
		// 			}
		// 		}
		// 		_this.modalView = true
		// 	},
		// 	modalCancel: function(actionType) {
		// 		this.modalView = false
		// 	},
		// 	modalOk: function(actionType) {
		// 		this.modalView = false
		// 	},
		}
	};
</script>
